import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import FormatUtils from '../common/formatUtils/FormatUtils';
import DateFormat from '../common/dateFormat/DateFormat';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'ESTOQUE_MANUAL_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}
export function initForm(registro = {}) {
    return [
        initialize('estoqueManualForm', registro)
    ];
}

export function getLista() {
    const request = axios.get(`${consts.API_URL}/estoqueManual`);
    return {
        type: 'ESTOQUE_MANUAL_LISTADO',
        payload: request
    };
}

export function salvar(registro) {
    return (dispatch, getState) => {
		if (!registro.id) {
	        axios.post(`${consts.API_URL}/estoqueManual`, {
                ...registro,
                datahora: DateFormat.formatarDataHoraTelaParaSql(registro.datahora),
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 0),
				quantidade_sobre_rodas: FormatUtils.formatarValorBanco(registro.quantidade_sobre_rodas, 0),
				custo_unitario: FormatUtils.formatarValorBanco(registro.custo_unitario, 4),
				valor_total: FormatUtils.formatarValorBanco(registro.valor_total, 2),
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/estoqueManual`, {
                ...registro,
                datahora: DateFormat.formatarDataHoraTelaParaSql(registro.datahora),
				quantidade: FormatUtils.formatarValorBanco(registro.quantidade, 0),
				quantidade_sobre_rodas: FormatUtils.formatarValorBanco(registro.quantidade_sobre_rodas, 0),
				custo_unitario: FormatUtils.formatarValorBanco(registro.custo_unitario, 4),
				valor_total: FormatUtils.formatarValorBanco(registro.valor_total, 2),
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
			}).catch(e => {
				setErroAPI(e);
			});
		}
    };
}

export function excluir(registro) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/estoqueManual?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaProduto() {
    const request = axios.get(`${consts.API_URL}/produto/listarSelect`);
    return {
        type: 'ESTOQUE_MANUAL_PRODUTO_SELECT_LISTADO',
        payload: request
    };
}

export function getListaUnidade() {
    const request = axios.get(`${consts.API_URL}/unidade/listarSelect`);
    return {
        type: 'ESTOQUE_MANUAL_UNIDADE_SELECT_LISTADO',
        payload: request
    };
}
